import type { ApiClient } from "./client";
import type { AnalyticsReport, AnalyticsSection, DateRange } from "./types";

/** Analytics: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface AnalyticsApi {
  report(section: AnalyticsSection, range: DateRange): Promise<AnalyticsReport>;
}

export function createHttpAnalyticsApi(client: ApiClient): AnalyticsApi {
  return {
    report: (section, range) => client.call("getAnalyticsReport", { params: { section }, query: { range } }),
  };
}
